<template>
    <ul v-if="$parent.items.data.length > 0" class="pagination float-end">
        <li class="page-item" v-show="$parent.items['prev_page_url']">
            <a href="#" class="page-link" @click.prevent="getPreviousPage">
                <span>
                    <span aria-hidden="true">«</span>
                </span>
            </a>
        </li>
        <li class="page-item" :class="{ 'active': ($parent.items['current_page']=== n) }" v-for="n in $parent.items['last_page']">
            <a href="#" class="page-link" @click.prevent="getPage(n)">
                <span >
                    {{ n }}
                </span>
            </a>
        </li>
        <li class="page-item" v-show="$parent.items['next_page_url']">
            <a href="#" class="page-link" @click.prevent="getNextPage">
                <span>
                    <span aria-hidden="true">»</span>
                </span>
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    name: "Pagination",
    props:{
        urlAppend: String,
    },
    mounted() {
        this.listItems();
    },
    methods:{
        async listItems(){
            let axiosRoute = (typeof this.$props.urlAppend === 'undefined') ? this.$parent.apiRoute:this.$parent.apiRoute + this.$props.urlAppend;

            await this.axios.get(axiosRoute)
                .then(response=>{
                    this.$parent.items = response.data
                })
                .catch(error=>{
                    this.$parent.items = {data:[]}
                })

        },
        async getPage(page){
            let axiosRoute = (typeof this.$props.urlAppend === 'undefined')?this.$parent.apiRoute+'?page='+page:this.$parent.apiRoute+this.$props.urlAppend+'&page='+page
            await this.axios.get(axiosRoute)
                .then((response)=>{
                    this.$parent.items = response.data;
                },(response)=>{
                    this.$parent.items = {data:[]}
                });
            $(window).scrollTop(0)
        },
        async getPreviousPage(){
            await this.axios.get(this.$parent.items['prev_page_url']).then((response)=>{
                this.$parent.items = response.data;
            },(response)=>{
                this.$parent.items = {data:[]}
            });
            $(window).scrollTop(0)
        },
        async getNextPage(){
            await this.axios.get(this.$parent.items['next_page_url']).then((response)=>{
                this.$parent.items = response.data;
            },(response)=>{
                this.$parent.items = {data:[]}
            });
            $(window).scrollTop(0)
        }
    },
    watch : {
        urlAppend: function (newVal, oldVal){
            this.listItems();
        }
    }
}
</script>

<style scoped>

</style>
